import prototype from './prototype';
import prototypeView from './prototypeView';

export default {
  prototype,
  prototypeView,
};
